module.exports = __webpack_public_path__ + "static/all-you-can-eat-crab-legs-6b91ee0a078d3c0777df9b3f87dfbb0c.jpg";